import _ from "lodash";

const isOwnFrame = (frame, origin) =>
  _.isString(frame.filename) && frame.filename.startsWith(`${origin}${process.env.PUBLIC_URL}/static/`);

/**
 * Whether an exception event comes only from code that isn't ours: none of its stack frames
 * belongs to the app's own bundles (`<origin><PUBLIC_URL>/static/...`). posthog-js marks every
 * browser frame as `in_app`, so the frame's filename is the only signal: scripts injected by
 * browsers or in-app webviews show up as `<anonymous>`, `undefined` or the page URL itself (inline
 * scripts), extensions as `chrome-extension://...`. Exceptions without frames can't be attributed
 * and are not considered foreign.
 */
export const isForeignException = (event, origin = window.location.origin) => {
  if (event?.event !== "$exception") return false;
  const frames = _.flatMap(event.properties?.$exception_list, (exception) => exception?.stacktrace?.frames ?? []);
  return frames.length > 0 && !frames.some((frame) => isOwnFrame(frame, origin));
};

export const dropForeignExceptions = (event) => (isForeignException(event) ? null : event);
